import { render, staticRenderFns } from "./DriverEvents.vue?vue&type=template&id=1db6deef&scoped=true&"
import script from "./DriverEvents.vue?vue&type=script&lang=js&"
export * from "./DriverEvents.vue?vue&type=script&lang=js&"
import style0 from "./DriverEvents.vue?vue&type=style&index=0&id=1db6deef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6deef",
  null
  
)

export default component.exports